import { RESOURCE_KEY, ResourceKey } from '@backrs_ui/grow-ui/src/models/models';
import { useGetCareerPathByIdQuery } from '@backrs_ui/grow-ui/src/redux/careerPath/careerPath.api';
import { useGetCoachByIdQuery } from '@backrs_ui/grow-ui/src/redux/coaches/coaches.api';
import { useGetCollegeByIdQuery } from '@backrs_ui/grow-ui/src/redux/college/college.api';
import { useGetCompetencyBySlugQuery } from '@backrs_ui/grow-ui/src/redux/contentCompetency/contentCompetency.api';
import { useGetContentNuggetByIdQuery } from '@backrs_ui/grow-ui/src/redux/contentNugget/contentNugget.api';
import { useGetDeepDiveByIdQuery } from '@backrs_ui/grow-ui/src/redux/deepDive/deepDive.api';
import { useGetEmployerByIdQuery } from '@backrs_ui/grow-ui/src/redux/employer/employer.api';
import { useGetIndustryByIdQuery } from '@backrs_ui/grow-ui/src/redux/industry/industry.api';
import { useGetInternshipByIdQuery } from '@backrs_ui/grow-ui/src/redux/internship/internship.api';
import { useGetMajorByCodeQuery } from '@backrs_ui/grow-ui/src/redux/major/major.api';
import { useGetSuggestedPlaylistByIdQuery } from '@backrs_ui/grow-ui/src/redux/priorities/priorities.api';
import { useGetScholarshipByIdQuery } from '@backrs_ui/grow-ui/src/redux/scholarship/scholarship.api';
import { useGetToolByToolIdQuery } from '@backrs_ui/grow-ui/src/redux/tools/tools.api';

/**
 * Fetches resource data by type and id using the appropriate RTK Query hook.
 * This is a shared hook used by ResourceNugget and other components
 * to avoid duplicating the fetch logic.
 */
export const useResourceData = (type: ResourceKey, id: string, skip = false) => {
  const { data: toolData } = useGetToolByToolIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.TOOLS,
  });
  const { data: collegeData } = useGetCollegeByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.COLLEGES,
  });
  const { data: internshipData } = useGetInternshipByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.INTERNSHIPS,
  });
  const { data: scholarshipData } = useGetScholarshipByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.SCHOLARSHIPS,
  });
  const { data: majorData } = useGetMajorByCodeQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.MAJORS,
  });
  const { data: industryData } = useGetIndustryByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.INDUSTRIES,
  });
  const { data: employerData } = useGetEmployerByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.EMPLOYERS,
  });
  const { data: competencyData } = useGetCompetencyBySlugQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.COMPETENCIES,
  });
  const { data: careerPathData } = useGetCareerPathByIdQuery(id, {
    skip: skip || !id || type !== RESOURCE_KEY.CAREER_PATHS,
  });
  const { data: contentNuggetData } = useGetContentNuggetByIdQuery(id, {
    skip:
      skip ||
      !id ||
      (type !== RESOURCE_KEY.LEARNING &&
        type !== RESOURCE_KEY.STORIES &&
        type !== RESOURCE_KEY.RESOURCES),
  });
  const { data: suggestedPlaybookData } = useGetSuggestedPlaylistByIdQuery(Number(id), {
    skip: skip || !id || type !== RESOURCE_KEY.SUGGESTED_PLAYBOOKS,
  });
  const { data: coachData } = useGetCoachByIdQuery(Number(id), {
    skip: skip || !id || type !== RESOURCE_KEY.COACHES,
  });
  const { data: deepDiveData } = useGetDeepDiveByIdQuery(Number(id), {
    skip: skip || !id || type !== RESOURCE_KEY.DEEP_DIVES,
  });

  return {
    toolData,
    collegeData,
    internshipData,
    scholarshipData,
    majorData,
    industryData,
    employerData,
    competencyData,
    careerPathData,
    contentNuggetData,
    suggestedPlaybookData,
    coachData,
    deepDiveData,
  };
};
